export function planDetailsLink(appSlug: string, planUuid: string) {
  return `/apps/${appSlug}/plans/${planUuid}`;
}

export function planEditLink(appSlug: string, planUuid: string) {
  return `/apps/${appSlug}/plans/${planUuid}/edit`;
}

export function plansLink(appSlug: string) {
  return `/apps/${appSlug}/plans`;
}

export function programDetailsLink(appSlug: string, programUuid: string) {
  return `/apps/${appSlug}/plans/programs/${programUuid}`;
}

export function playbookSectionLink({ slug }: { slug: string }) {
  return `/playbook/section/${slug}`;
}

export function playbookGuideLink({
  short_id,
  slug,
}: {
  short_id: string;
  slug?: string;
}) {
  return `/playbook/guides/${short_id}${slug ? `/${slug}` : ""}`;
}

export function playbookFAQLink({
  short_id,
  slug,
}: {
  short_id: string;
  slug?: string;
}) {
  return `/playbook/faqs/${short_id}${slug ? `/${slug}` : ""}`;
}

/**
 * Marks a navigation as opening or closing an overlay over the page you are
 * already on, so the layout leaves your scroll position where it was.
 */
export const PRESERVE_SCROLL = { state: { preserveScroll: true } } as const;

export function isPreserveScrollState(state: unknown): boolean {
  return (
    typeof state === "object" &&
    state !== null &&
    "preserveScroll" in state &&
    state.preserveScroll === true
  );
}
